import React from 'react'

const FlightBookings = () => {
    return (
        <div>FlightBookings</div>
    )
}

export default FlightBookings